import { UserType } from "@/config";

export default [
  {
    path: "/admin/customers",
    name: "CustomerIndex",
    component: () =>
      import(/* webpackChunkName: "customers" */ "@/views/admin/customers/CustomerIndex.vue"),
    children: [
      {
        name: "CustomerForm",
        path: ":customerId",
        component: () =>
          import(
            /* webpackChunkName: "customers" */ "@/views/admin/customers/CustomerForm.vue"),
        props: true,
      },
      {
        name: "CustomerEdit",
        path: ":customerId/edit",
        component: () =>
          import(
            /* webpackChunkName: "customers" */ "@/views/admin/customers/CustomerForm.vue"),
        props: true,
      },
      {
        name: "CustomerUsers",
        path: ":customerId/users",
        component: () =>
          import(
            /* webpackChunkName: "customers" */ "@/views/admin/customers/CustomerUsers.vue"
            ),
        props: true,
      },
    ],
    meta: { allowedUsers: [UserType.CSR], permission: "customer:admin"},
  }
];
